import React from 'react';
import { Alert, Typography } from 'antd';

/** Keeps the public calculator embed from failing as a blank page. */
export default class CalculatorErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[Bidmanager calculator] render error', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;

    if (error) {
      return (
        <Alert
          type="error"
          showIcon
          message="Calculator could not render"
          description={
            <Typography.Text style={{ wordBreak: 'break-word' }}>
              {String(error?.message || error)}
            </Typography.Text>
          }
          style={{ margin: 16 }}
        />
      );
    }

    return this.props.children;
  }
}
